import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import './Legal.css';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  useDocumentTitle('Privacy Policy');

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          Back
        </button>

        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: March 23, 2026</p>

        <section>
          <h2>1. Information We Collect</h2>
          <h3>Account Information</h3>
          <p>
            When you create an account, we collect your email address, name, and
            authentication credentials. If you sign in with Google, we receive your
            name, email, and profile picture from Google.
          </p>
          <h3>Procurement Data</h3>
          <p>
            You may upload procurement data (CSV/Excel files) for classification and
            analysis. This data is stored securely in our database and processed solely
            to provide the Service.
          </p>
          <h3>Usage Data</h3>
          <p>
            We collect information about how you interact with the Service, including
            pages visited, features used, and actions taken, to improve the product.
          </p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain the Service</li>
            <li>To authenticate your identity and manage access</li>
            <li>To classify and analyze procurement data using AI models</li>
            <li>To improve the Service and develop new features</li>
            <li>To communicate with you about your account and the Service</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Storage and Security</h2>
          <p>
            Your data is stored in a PostgreSQL database hosted by Supabase with
            SSL/TLS encryption in transit and at rest. We implement role-based
            access control and audit logging to protect your data.
          </p>
        </section>

        <section>
          <h2>4. AI Processing</h2>
          <p>
            Procurement data may be processed by AI services (Anthropic Claude, OpenAI GPT-4)
            for classification purposes. Data sent to AI services is used solely for
            classification and is not retained by those services for training.
          </p>
        </section>

        <section>
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell your personal information. We may share data with:
          </p>
          <ul>
            <li>Service providers who assist in operating the platform (hosting, AI services)</li>
            <li>Law enforcement when required by law</li>
            <li>Other users within your organization based on role-based access settings</li>
          </ul>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            We retain your data for as long as your account is active. You may request
            deletion of your account and associated data by contacting us.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your procurement data</li>
          </ul>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>
            For privacy-related questions, contact us at{' '}
            <a href="mailto:support@tekstak.app">support@tekstak.app</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
